export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';

export const loginSuccess = (user, token) => ({
    type: LOGIN_SUCCESS,
    payload: { user, token }
});

export const logout = () => ({
    type: LOGOUT
});

export const fetchUser = () => async (dispatch) => {
    try {
        const token = sessionStorage.getItem("token");
        if (!token) throw new Error("No token");
        const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
        const res = await fetch(`${BASE_URL}/api/auth/user`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!res.ok) {
            throw new Error("Failed to fetch user");
        }

        const data = await res.json();

        dispatch(loginSuccess(data.user, token));
    } catch (err) {
        console.error("Fetch user error:", err.message);
        dispatch(logout());
    }
};